var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.color)?_c('g',_vm._l((_vm.group),function(path,index){return _c('path',{key:index,style:({ fill: _vm.color.hex }),attrs:{"d":path}})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }